/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Audit_Details_Integration_Disconnected_External_DescInputs */



/**
* | output |
* | --- |
* | "The {provider} integration was disconnected because {provider} revoked the connection on its own side — no one in this organisation triggered it." |
*
* @param {Audit_Details_Integration_Disconnected_External_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_integration_disconnected_external_desc = /** @type {((inputs: Audit_Details_Integration_Disconnected_External_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Integration_Disconnected_External_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Integration ${i?.provider} wurde getrennt, weil ${i?.provider} die Verbindung auf eigener Seite widerrufen hat — niemand in dieser Organisation hat das ausgelöst.`)
	return /** @type {LocalizedString} */ (`The ${i?.provider} integration was disconnected because ${i?.provider} revoked the connection on its own side — no one in this organisation triggered it.`)
});